import { render, staticRenderFns } from "./CenarioCorpoMercadoria.vue?vue&type=template&id=aa31ad9c&scoped=true&"
import script from "./CenarioCorpoMercadoria.vue?vue&type=script&lang=js&"
export * from "./CenarioCorpoMercadoria.vue?vue&type=script&lang=js&"
import style0 from "./CenarioCorpoMercadoria.vue?vue&type=style&index=0&id=aa31ad9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa31ad9c",
  null
  
)

export default component.exports